// ====================== ASTROGLOW ANIMATIONS ======================

// Curseur personnalisé doré
const cursor = document.createElement('div');
cursor.style.cssText = `
  position: fixed; width: 24px; height: 24px; border: 2px solid #c9a84c; 
  border-radius: 50%; pointer-events: none; z-index: 9999; 
  transform: translate(-50%, -50%); mix-blend-mode: screen; transition: all 0.1s;
`;
document.body.appendChild(cursor);

document.addEventListener('mousemove', (e) => {
  cursor.style.left = e.clientX + 'px';
  cursor.style.top = e.clientY + 'px';
});

// Canvas Étoiles scintillantes
const canvas = document.createElement('canvas');
canvas.id = 'starCanvas';
canvas.style.position = 'fixed';
canvas.style.top = '0';
canvas.style.left = '0';
canvas.style.width = '100%';
canvas.style.height = '100%';
canvas.style.zIndex = '0';
canvas.style.pointerEvents = 'none';
document.body.appendChild(canvas);

const ctx = canvas.getContext('2d');

function resizeCanvas() {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
}
resizeCanvas();
window.addEventListener('resize', resizeCanvas);

const stars = [];
for (let i = 0; i < 300; i++) {
  stars.push({
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height,
    radius: Math.random() * 1.8,
    alpha: Math.random(),
    speed: Math.random() * 0.006 + 0.002
  });
}

function drawStars() {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  stars.forEach(star => {
    star.alpha += star.speed;
    if (star.alpha > 1 || star.alpha < 0.3) star.speed *= -1;

    ctx.beginPath();
    ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
    ctx.fillStyle = '#c9a84c';
    ctx.globalAlpha = star.alpha * 0.9;
    ctx.fill();
  });
  requestAnimationFrame(drawStars);
}
drawStars();

// Paillettes flottantes
function createSparkle() {
  const sparkle = document.createElement('div');
  sparkle.textContent = ['✦', '✧', '⋆', '★', '✹'][Math.floor(Math.random()*5)];
  sparkle.style.position = 'fixed';
  sparkle.style.left = Math.random() * 100 + 'vw';
  sparkle.style.top = '-20px';
  sparkle.style.fontSize = (Math.random() * 8 + 6) + 'px';
  sparkle.style.color = Math.random() > 0.5 ? '#c9a84c' : '#e0aaff';
  sparkle.style.opacity = '0';
  sparkle.style.zIndex = '1';
  sparkle.style.pointerEvents = 'none';
  sparkle.style.animation = `floatSparkle ${Math.random()*12 + 15}s linear forwards`;
  document.body.appendChild(sparkle);

  setTimeout(() => sparkle.remove(), 30000);
}

setInterval(createSparkle, 400);

// Animation CSS pour paillettes
const style = document.createElement('style');
style.textContent = `
  @keyframes floatSparkle {
    0% { transform: translateY(100vh) rotate(0deg); opacity: 0; }
    10% { opacity: 0.9; }
    90% { opacity: 0.6; }
    100% { transform: translateY(-20px) rotate(360deg); opacity: 0; }
  }
`;
document.head.appendChild(style);
